<template>
  <div>
    <van-sticky>
      <van-tabs
        @click="onClickOnlyOne"
        color="#16bbbf"
        title-active-color="#16bbbf"
      >
        <van-tab name="全部" title="全部"> </van-tab>
        <van-tab name="美文" title="美文"> </van-tab>
        <van-tab name="美景" title="美景"> </van-tab>
        <van-tab name="美食" title="美食"> </van-tab>
        <van-tab name="其他" title="其他"> </van-tab>
        <van-tab name="我的" title="我的"> </van-tab>
      </van-tabs>
    </van-sticky>
    

    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass" v-for="item in list" :key="item.index">
        <div @click="gotoUrl('/submissions/detail/' + item.Id)">
          <div class="Content">
            <div
              style="display: inline-block; width: 33%"
              class="ContentA"
              ref="getHeight"
            >
              <img
                v-if="item.Imgs"
                style="
                  border-radius: 5px;
                  height: 90px;
                  object-fit: cover;
                  display: block;
                "
                :src="item.Imgs.split(',')[0]"
                alt=""
              />
              <img
                v-else
                style="
                  border-radius: 5px;
                  height: 90px;
                  object-fit: cover;
                  display: block;
                "
                src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                alt=""
              />
            </div>
            <div style="display: inline-block; width: 63%" class="ContentB">
              <div class="centerTitle van-multi-ellipsis--l2">
                {{ item.Title }}
              </div>
              <!-- <span
                class="centertime van-multi-ellipsis--l2"
                style="margin: 5px 0px; font-size: 13px; color: #666666"
                >{{ item.Summary }}</span
              > -->
            </div>
            <span
              class="centertime"
              style="
                float: right;
                margin-right: 6px;
                margin-top: -18px;
                color: black;
                color: #999;
              "
              >{{ item.CreateTime | timeFilter }}</span
            >
          </div>
        </div>
      </div>
      <!-- 没有更多数据了 -->
      <div v-if="hidden" class="hidden">── 没有更多数据了 ──</div>
    </div>
    <!-- 发布活动 -->
    <div class="backTop" @click="gotoUrl('/submissions/addActivity')">
      <!-- v-if="isWorkMan == 1" -->
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId, getIsWorkMan } from "@/utils/auth";
import { GetSubmissionsPage } from "@/api/RealInfo";
export default {
  data() {
    return {
      isWorkMan: "",
      tkId: 0, //tab栏
      activeName: "",
      list: {}, //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
        Status: 2,
        type:null,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [
        {
          id: 1,
          name: "街道",
        },
        {
          id: 2,
          name: "社区",
        },
      ],
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    // 发布活动
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },

    // 获取分页列表
    getList() {
      GetSubmissionsPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.count == 0) {
              this.list = {};
            } else {
              this.list = res.data.data;
              console.log(res.data.data);
              // for (var i = 0; i < this.list.length; i++) {
              //   if (this.list[i].Thematic == '') {
              //     this.list[i].Thematic = 'http://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png'
              //   }
              // }
            }
          }
        })
        .catch(() => {});
    },

    // tab点击切换事件
    onClick(name, title) {
      this.list = [];
      this.listfrom.TKId = name;
      this.listfrom.page = 1;
      this.getList();
    },
    onClickOnlyOne(name, title) {
      console.log(name);
      if (name == "全部") {
        this.listfrom.page = 1;
        this.listfrom.type=null;
        this.list = [];
        this.listfrom.Status = 2;
        this.listfrom.UserId = null;
        this.getList();
      }
      if (name == "我的") {
        this.listfrom.page = 1;
        this.listfrom.type=null;
        this.list = [];
        this.listfrom.Status = null;
        // this.listfrom.UserId = getOpenId();
        this.getList();
      }
      if(name=="美文"){
        this.listfrom.page = 1;
        this.listfrom.type=1;
        this.listfrom.Status = null;
        this.list = [];
        this.listfrom.Status = null;
        this.getList();
      }
      if(name=="美景"){
        this.listfrom.page = 1;
        this.listfrom.type=2;

        this.list = [];
        this.listfrom.Status = null;
        this.getList();
      }
      if(name=="美食"){
        this.listfrom.page = 1;
        this.listfrom.type=3;
        this.list = [];
        this.listfrom.Status = null;
        this.getList();
      }
      if(name=="其他"){
        this.listfrom.page = 1;
        this.listfrom.type=0;
        this.list = [];
        this.listfrom.Status = null;
        this.getList();
      }
    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.isWorkMan = getIsWorkMan();
    this.getList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}
</style>
